import React from 'react'
import * as S from './styles'
import {  useNavigation } from "@react-navigation/native";

type HeaderNavigationProps = {
  title: string
  enableButtonLeft: boolean
  enableButtonRight: boolean
}

const HeaderNavigation: React.FC<HeaderNavigationProps> = ({ title, enableButtonLeft, enableButtonRight }) => {

  const navigation = useNavigation()

  return (
    <S.HeaderContainer>
      {enableButtonLeft &&
        <S.HeaderButton position="left" onPress={() => navigation.navigate('Loja')}>
          <S.HeaderLink>
            Voltar
          </S.HeaderLink>
        </S.HeaderButton>
      }
      <S.HeaderTitle>
        {title}
      </S.HeaderTitle>
      {enableButtonRight &&
          <S.HeaderButton position="right" onPress={() => navigation.navigate("Support")}>
            <S.HeaderLink>
              Ajuda
            </S.HeaderLink>
          </S.HeaderButton>
      }
    </S.HeaderContainer>
  )
}

export default HeaderNavigation;